export default __webpack_public_path__ + "static/media/icon-porcentagem-transferencia.6bdcb33d.svg";